import { useEffect, useState } from "react";
import { Settings as SettingsIcon, BellRing, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import api, { formatApiError } from "@/lib/api";
import { QuotationTermsEditor } from "@/components/QuotationTermsEditor";
import { QuotationEmailTemplateEditor } from "@/components/QuotationEmailTemplateEditor";
import { RentalDefaultsEditor } from "@/components/RentalDefaultsEditor";

export default function SchedulingSettings() {
  const [cfg, setCfg] = useState(null);
  const [emailCfg, setEmailCfg] = useState(null);
  useEffect(() => { api.get("/settings/scheduling").then((r) => setCfg(r.data)).catch((e) => toast.error(formatApiError(e))); }, []);
  useEffect(() => { api.get("/settings/email").then((r) => setEmailCfg(r.data)).catch(() => {}); }, []);
  const toggleEmail = async (v) => {
    try {
      const r = await api.put("/settings/email", { quotation_email_enabled: v });
      setEmailCfg(r.data);
      toast.success(v ? "Quotation emailing from ERP turned on" : "Quotation emailing from ERP turned off");
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const toggle = async (v) => {
    try {
      const r = await api.put("/settings/scheduling", { ...cfg, evening_reminder_enabled: v });
      setCfg(r.data);
      toast.success(v ? "Evening reminders turned on" : "Evening reminders turned off");
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div data-testid="settings-page" className="max-w-3xl">
      <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">Masters</div>
      <h1 className="font-heading text-2xl md:text-3xl font-semibold text-slate-900 flex items-center gap-2 mb-6">
        <SettingsIcon className="w-6 h-6 text-indigo-600" /> Settings
      </h1>
      <section className="bg-white border border-slate-200 rounded-lg p-5 flex items-start justify-between gap-4">
        <div className="flex gap-3">
          <div className="w-9 h-9 rounded-md bg-indigo-50 text-indigo-700 flex items-center justify-center shrink-0"><BellRing className="w-4 h-4" /></div>
          <div>
            <div className="font-semibold text-slate-900">Evening-before visit reminders</div>
            <p className="text-sm text-slate-500 mt-1">Every day at 6:00 PM IST, email each engineer a reminder for the visits they have scheduled the next day.</p>
          </div>
        </div>
        <Switch checked={!!cfg?.evening_reminder_enabled} disabled={!cfg} onCheckedChange={toggle} data-testid="reminder-toggle" />
      </section>
      <section className="mt-4 bg-white border border-slate-200 rounded-lg p-5 flex items-start justify-between gap-4" data-testid="email-sending-setting">
        <div className="flex gap-3">
          <div className="w-9 h-9 rounded-md bg-indigo-50 text-indigo-700 flex items-center justify-center shrink-0"><MailCheck className="w-4 h-4" /></div>
          <div>
            <div className="font-semibold text-slate-900">Enable email sending from ERP</div>
            <p className="text-sm text-slate-500 mt-1">When on, Draft quotations get a "Send" button that opens an editable cover email, sends it with the PDF from sales@hubaifuturetech.com and marks the quotation Sent. When off, quotations are never emailed: users download the PDF, send it themselves, and use Mark as Sent.</p>
          </div>
        </div>
        <Switch checked={!!emailCfg?.quotation_email_enabled} disabled={!emailCfg} onCheckedChange={toggleEmail} data-testid="email-sending-toggle" />
      </section>
      <QuotationEmailTemplateEditor />
      <RentalDefaultsEditor />
      <QuotationTermsEditor />
    </div>
  );
}
